module.exports = __webpack_public_path__ + "media/new/star-grey-29c713a1.svg";